/**
 * It used to replace any value with our preferable value
 * @Syntax ---> "algoTestId":{"expectedValue (from client)": "expectingValue"}
 * @algoTestId -- should be a number
 * @expectedValue -- should be a lowercase string
 */

export const ALGO_VALUE_MAPPER:{[key:number]:{[key:string]:number | string}}={
    146:{
        "notincreased": 0
    }
}
